// Module
var code = `<div class="d-flex align-items-center justify-content-center" style="min-height: calc(100vh - 56px)">
	<div class="col-11 col-sm-8 col-md-5 col-lg-4">
		<div class="text-center mb-4">
			<i class="fas fa-tv fa-3x mb-3" style="color: #f57c00"></i>
			<h1 class="mb-1">JumboTRON</h1>
		</div>
		<div class="card shadow">
			<div class="card-body p-4 text-center">
				<div ng-if="\$ctrl.error" class="alert alert-danger py-2 mb-0" role="alert">
					<i class="fas fa-exclamation-circle me-1"></i> {{ \$ctrl.error }}
				</div>
				<div ng-if="!\$ctrl.error">
					<i class="fas fa-circle-notch fa-spin fa-2x mb-3" style="color: #f57c00"></i>
					<p class="text-muted mb-0">Signing you in, please wait...</p>
				</div>
			</div>
		</div>
		<p class="text-center text-muted mt-3" style="font-size: 0.8em">&copy; Roskilde Festival</p>
	</div>
</div>
`;
// Exports
export default code;